import { type FC, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { GOOGLE_RECAPTCHA_SITE_KEY_V3 } from 'shared/config'
import { ProviderReCaptchaV3 } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV3/context/reCaptchaV3Context'
import { type ReCaptchaV3Store } from 'entities/Auth/ui/ReCaptcha/ui/ReCaptchaV3/store/reCaptchaV3Store'

type IReCaptchaV3LayoutProps = {
  store: ReCaptchaV3Store
  children: ReactNode
}

export const ReCaptchaV3Layout: FC<IReCaptchaV3LayoutProps> = observer(({ store, children }) => {
  return (
    <ProviderReCaptchaV3 value={store}>
      <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_SITE_KEY_V3}>
        {children}
      </GoogleReCaptchaProvider>
    </ProviderReCaptchaV3>
  )
})
